import React from "react";
import { IonToolbar } from "@ionic/react";
import "./footer.layout.css";

const Footer = () => {
  return (
    <IonToolbar className="footer">
      <p>© Cosmilano srl - P.Iva 10710180158 | Design by Kotuko</p>
    </IonToolbar>
  );
};

export default Footer;
